"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var material_1 = require("@mui/material");
var Clear_1 = __importDefault(require("@mui/icons-material/Clear"));
var mountIsland_1 = require("../mountIsland");
var Lang_js_1 = require("../Lang.js");
var SeedcardForm_1 = __importDefault(require("./SeedcardForm"));
var ImageSelection_1 = __importDefault(require("./ImageSelection"));
var Stepper_1 = __importDefault(require("../Generic/Stepper"));
var Seedcard = function () {
    var base = document.getElementById('seedcard').getAttribute('data-base');
    var _a = (0, react_1.useState)(false), isImageSaving = _a[0], setImageSaving = _a[1];
    var _b = (0, react_1.useState)(false), isFormSaving = _b[0], setFormSaving = _b[1];
    var _c = (0, react_1.useState)(false), isImageSelected = _c[0], setImageSelected = _c[1];
    var _d = (0, react_1.useState)(null), selectedImage = _d[0], setSelectedImage = _d[1];
    var _e = (0, react_1.useState)(0), activeStep = _e[0], setActiveStep = _e[1];
    var steps = [(0, Lang_js_1.__)('Choose a Card'), (0, Lang_js_1.__)('Enter Delivery Details'), (0, Lang_js_1.__)('Place Your Seed')];
    var getStepLabel = function () {
        return steps[activeStep];
    };
    var handleNext = function () {
        var _a;
        setActiveStep(function (prevActiveStep) { return prevActiveStep + 1; });
        var selectedImageEl = document.getElementById('selected-image');
        if (selectedImageEl) {
            selectedImageEl.classList.remove('fadeOut');
            selectedImageEl.classList.add('zoom1x');
        }
        (_a = document.querySelector('a[name="top"]')) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    };
    var handleBack = function () {
        var _a;
        setActiveStep(function (prevActiveStep) { return prevActiveStep - 1; });
        var selectedImageEl = document.getElementById('selected-image');
        if (selectedImageEl) {
            selectedImageEl.classList.remove('zoom1x');
            selectedImageEl.classList.add('fadeOut');
        }
        (_a = document.querySelector('a[name="top"]')) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    };
    var saveSeedcard = function (seedcardData) {
        setFormSaving(true);
        axios_1.default.post('/api/seedcard/insert', seedcardData)
            .then(function (response) {
            console.log('E-card saved:', response.data);
            setFormSaving(false);
            var type = (0, Lang_js_1.__)('Seed');
            window.location.href =
                '/app/donate?type=' + encodeURIComponent(type) +
                    '&comment1=seedcard' +
                    '&comment2=' + encodeURIComponent(seedcardData.recipient_name) +
                    '&comment3=' + encodeURIComponent(response.data.seedcard_unique_id) +
                    '&email=' + encodeURIComponent(seedcardData.sender_email) +
                    '&amount=' + Math.round(parseFloat(String(seedcardData.amount)) * 100) +
                    '&origin=seedcard';
        })
            .catch(function (error) {
            console.error('Error saving e-card:', error);
            setFormSaving(false);
        });
    };
    var handleImageSelect = function (image) {
        setImageSaving(true);
        setSelectedImage(image);
        setImageSaving(false);
        setImageSelected(true);
    };
    return (react_1.default.createElement(material_1.Box, null,
        react_1.default.createElement(material_1.Box, { id: "top" }),
        react_1.default.createElement(Stepper_1.default, { steps: steps, activeStep: activeStep }),
        react_1.default.createElement(material_1.Typography, { variant: "inherit", component: "h3", m: 4 },
            activeStep + 1,
            ". ",
            getStepLabel()),
        react_1.default.createElement(material_1.Modal, { open: isFormSaving, onClose: function () { return; }, "aria-labelledby": "modal-modal-title", "aria-describedby": "modal-modal-description" },
            react_1.default.createElement(material_1.Box, { display: "flex", width: "100%", height: "100%", justifyContent: "center", alignItems: "center", bgcolor: "white" },
                react_1.default.createElement(material_1.Box, { id: "modal-modal-title", sx: { display: 'flex', justifyContent: 'center' } },
                    react_1.default.createElement(material_1.CircularProgress, null)),
                react_1.default.createElement(material_1.Box, { sx: { display: 'flex', justifyContent: 'center', minHeight: '3rem', ml: 2 } },
                    react_1.default.createElement(material_1.Typography, { id: "modal-modal-description", sx: { mt: 2 } }, (0, Lang_js_1.__)('Please wait...'))))),
        !isImageSelected && (react_1.default.createElement(material_1.Box, null,
            react_1.default.createElement(ImageSelection_1.default, { onSelectImage: handleImageSelect, handleNext: handleNext }))),
        isImageSaving && (react_1.default.createElement(material_1.Box, null,
            react_1.default.createElement(material_1.CircularProgress, null))),
        isImageSelected && (react_1.default.createElement(material_1.Box, { className: "row mt-4" },
            react_1.default.createElement(material_1.Box, { className: "col-md-6 mx-auto" },
                react_1.default.createElement(material_1.Box, { className: "card" },
                    react_1.default.createElement(material_1.Box, { component: "img", id: "selected-image", className: "card-img-top zoom1x", src: base + selectedImage, alt: "Selected Image" }),
                    react_1.default.createElement(material_1.Typography, { variant: "button", component: "p", className: "text-center" },
                        react_1.default.createElement(material_1.Box, { component: "a", href: "#top", onClick: function () {
                                handleBack();
                                window.setTimeout(function () { setImageSelected(false); }, 500);
                            } },
                            react_1.default.createElement(Clear_1.default, null),
                            (0, Lang_js_1.__)('Change Image'))),
                    react_1.default.createElement(material_1.Box, { className: "card-body" },
                        react_1.default.createElement(SeedcardForm_1.default, { onSaveSeedcard: saveSeedcard, selectedImage: selectedImage }))))))));
};
var seedcardContainer = document.getElementById('seedcard');
if (seedcardContainer) {
    (0, mountIsland_1.mountIsland)(seedcardContainer, react_1.default.createElement(Seedcard, null));
}
